import { Entry } from '../Entry'

export function Entry20250122() {
  return (
    <Entry title="2025 Jan 22 - v3.10.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16166/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
